// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__3pEgS","Open":"SideDrawer_Open__Z5qIE","Close":"SideDrawer_Close__1NHgJ","Logo":"SideDrawer_Logo__2QTuC"};